module.exports = {"notification.message":"Wix.com bruker informasjonskapsler for å gi deg best mulig opplevelse.","notification.got.it":"Ok","notification.more.info":"Les mer","notification.got.it.arrow":"arrow icon"}


//////////////////
// WEBPACK FOOTER
// ./assets/locale/messages_no.json
// module id = 54
// module chunks = 0